function text(value) {
  return typeof value === "string" ? value.trim() : "";
}

function localizedText(source, field, lang) {
  const language = lang === "es" ? "es" : "en";
  const fallbackLanguage = language === "es" ? "en" : "es";
  return text(source?.[`${field}_${language}`]) || text(source?.[`${field}_${fallbackLanguage}`]);
}

function uniqueLabels(labels) {
  const seen = new Set();
  return labels.filter((label) => {
    const key = label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function splitHighlights(value) {
  const raw = text(value).replace(/\r/g, "");
  if (!raw) return [];
  const lines = raw.split(/\n+/).map(text).filter(Boolean);
  return lines.length > 1
    ? lines
    : raw.split(/[;,·•]/).map(text).filter(Boolean);
}

// The supplied amenities are the category's selected public amenities, not the
// hotel's full inventory. Keep them separate from the commercial narrative.
export function buildRoomCategoryDetails({ beCopy, amenities, lang } = {}) {
  const copy = beCopy && typeof beCopy === "object" && !Array.isArray(beCopy) ? beCopy : null;
  const amenityNames = (Array.isArray(amenities) ? amenities : []).map((amenity) => {
    if (typeof amenity === "string") return text(amenity);
    if (!amenity || typeof amenity !== "object" || Array.isArray(amenity)) return "";
    return localizedText(amenity, "name", lang) || text(amenity.name) || text(amenity.code);
  }).filter(Boolean);

  return {
    view: localizedText(copy, "view", lang),
    highlights: uniqueLabels(splitHighlights(localizedText(copy, "highlights", lang))),
    amenities: uniqueLabels(amenityNames),
  };
}
